import { FETCH_API } from "../../middleware";

/* * * * * * * * * * * * * * * * * * * * */
/* POST - Images for Inventory item  * * */
/* * * * * * * * * * * * * * * * * * * * */
export const MODIFY_INVENTORY_IMAGES_REQUEST = 'MODIFY_INVENTORY_IMAGES_REQUEST';
export const MODIFY_INVENTORY_IMAGES_SUCCESS = 'MODIFY_INVENTORY_IMAGES_SUCCESS';
export const MODIFY_INVENTORY_IMAGES_FAILURE = 'MODIFY_INVENTORY_IMAGES_FAILURE';

const fetchModifyInventoryImages = (itemId, images) => {
    return {
        [FETCH_API]: {
            body: JSON.stringify({images}),
            endpoint: `seller/inventory/${itemId}/images?apiKey=`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            method: 'POST',
            types: [MODIFY_INVENTORY_IMAGES_REQUEST, MODIFY_INVENTORY_IMAGES_SUCCESS, MODIFY_INVENTORY_IMAGES_FAILURE],
        }
    }
}

/** Action for updating image presentation order for a vehicle
 * @param {number} itemId `id` of inventory item
 * @param {{url:string}[]} images updated list of images
 * @returns 
 */
export const loadModifyInventoryImages = (itemId, images=[]) => {
    return dispatch => {
        return dispatch(fetchModifyInventoryImages(itemId, images));
    }
}

export const RESET_MODIFY_INVENTORY_IMAGES = 'RESET_MODIFY_INVENTORY_IMAGES';
export const resetModifyInventorySellerImages = () => {
    return {type: RESET_MODIFY_INVENTORY_IMAGES}
}

/* * * * * * * * * * * * * * * * * * * * */
/* GET - Images for Inventory item * * * */
/* * * * * * * * * * * * * * * * * * * * */
export const INVENTORY_IMAGES_REQUEST = 'INVENTORY_IMAGES_REQUEST';
export const INVENTORY_IMAGES_SUCCESS = 'INVENTORY_IMAGES_SUCCESS';
export const INVENTORY_IMAGES_FAILURE = 'INVENTORY_IMAGES_FAILURE';

const fetchInventoryImages = (itemId) => {
    return {
        [FETCH_API]: {
            endpoint: `seller/inventory/${itemId}/images?apiKey=`,
            method: 'GET',
            types: [INVENTORY_IMAGES_REQUEST, INVENTORY_IMAGES_SUCCESS, INVENTORY_IMAGES_FAILURE],
        }
    }
}

/** Action for loading image presentation order for a vehicle
 * @param {number} itemId `id` of inventory item
 * @returns {Promise<{wsStatus: string, wsMessage: string, apiKey: string, images: {url: string}[]}>}
 */
export const loadInventoryImages = (itemId) => {
    return dispatch => {
        return dispatch(fetchInventoryImages(itemId));
    }
}

export const RESET_INVENTORY_IMAGES = 'RESET_INVENTORY_IMAGES';
export const resetGetInventoryImages = () => {
    return {type: RESET_INVENTORY_IMAGES}
}